import React from 'react'
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import classes from './veryNewProposalDesign.module.scss'
import moment from 'moment';
import { CarSvg, FerrySvg, TickSvg, TrainSvg } from '../../constants/resources';
import { ItineraryCarRental, ItineraryFerry, ItineraryTrain, SortedItem } from '../../atom/Types';

interface props {
  node: SortedItem[]
  handleCarRental?: (n: ItineraryCarRental[], m: string) => void
  handleTrain?: (n: ItineraryTrain[], m: string,) => void
  handleFerry?: (n: ItineraryFerry[], m: string) => void;
  ind: number
}

const CommonDisplayCard: React.FC<props> = ({ node, handleCarRental, handleFerry, handleTrain }) => {

  function isCarRental(item: SortedItem): item is ItineraryCarRental {
    return item.type === 'carRental';
  }
  function isTrain(item: SortedItem): item is ItineraryTrain {
    return item.type === 'train';
  }
  function isFerry(item: SortedItem): item is ItineraryFerry {
    return item.type === 'ferry';
  }

  const carRental = node?.filter((n) => (n.type === "carRental" && n?.selected === true))
  const trainRental = node?.filter((n) => (n.type === "train" && n?.selected === true))
  const ferryRental = node?.filter((n) => (n.type === "ferry" && n?.selected === true))

  const handleNode = (node: SortedItem[]) => {

    if (node[0].type === "carRental" && handleCarRental) {
      const product = node.filter(isCarRental)
      handleCarRental(product, 'ind')
    }
    else if (node[0]?.type === 'train' && handleTrain) {
      const product = node.filter(isTrain)
      handleTrain(product, 'ind')
    }
    else if (node[0]?.type === 'ferry' && handleFerry) {
      const product = node.filter(isFerry)
      handleFerry(product, 'ind')
    }
  }
  return (
    <div className={classes.displayCard}>
      <div className={classes.carView}>
        {node[0]?.type === 'carRental' ?
          <div style={{ display: 'flex' }}>
            <CarSvg width={"60"} height={"60"} />
            <p>select a car</p>
          </div> : node[0]?.type === 'train' ? <div style={{ display: 'flex' }}>
            <TrainSvg width='60' height='60' />
            <p>select a train</p>
          </div>
            : node[0]?.type === 'ferry' ? <div style={{ display: 'flex' }}>
              <FerrySvg width='60' height='60' />
              <p>select a ferry</p>
            </div>
              : null}
        <div className={classes.arrowStyle} onClick={() => handleNode(node)}>Details
          <span><KeyboardArrowRightIcon /></span></div>
      </div>
      {carRental.length > 0 ?
        carRental.filter(isCarRental).map((node) => {
          return <div className={classes.carRentalBottom}>
            <div className={classes.head}> <span>
              <TickSvg />
            </span>{node?.provider}/{node?.carType}</div>
            <div className={classes.commoncardwidth}>
              <div><span style={{ marginLeft: '20px' }}></span>{moment.utc(node?.pickUpDate).format('MMM D')}-{moment.utc(node?.dropOffDate).format('MMM D')}</div>
              <div>{node?.bookingStatus}</div>
            </div>
          </div>
        }) : trainRental.length > 0 ?
          trainRental.filter(isTrain).map((node) => {

            return <div className={classes.carRentalBottom}>
              <div className={classes.head}> <span>
                <TickSvg />
              </span>{node.trainType !== null && node.trainType !== "" ? node.trainType : 'High-speed'},{node.class !== null && node.class !== "" ? node.class : 'First Class'}</div>
              <div className={classes.commoncardwidth}>
                <div><span style={{ marginLeft: '20px' }}></span>{moment.utc(node?.departDate).format('MMM D')}-{moment.utc(node?.arrivalDate).format('MMM D')}</div>
                <div>{node?.bookingStatus}</div>
              </div>
            </div>
          }) : ferryRental.length > 0 ?
            ferryRental.filter(isFerry).map((node) => {
              return <div className={classes.carRentalBottom}>
                <div className={classes.head}> <span>
                  <TickSvg />
                </span>High-speed,First class</div>
                <div className={classes.commoncardwidth}>
                  <div><span style={{ marginLeft: '20px' }}></span>{moment.utc(node?.departDate).format('MMM D')}-{moment.utc(node?.arrivalDate).format('MMM D')}</div>
                  <div>{node?.bookingStatus}</div>
                </div>
              </div>
            }) : null
      }
    </div>
  )
}

export default CommonDisplayCard